//@ts-check
export function getHashParams() {

    const hashString = window.location.hash
    const params = {}

    if (!hashString) return params

    const decodedString = decodeURIComponent(hashString.slice(1))

    decodedString
        .split('&')
        .map(kv => kv.split('='))
        .filter(([k, v]) => (!!k && !!v))
        .forEach(([k, v]) => params[k] = v)

    return params
}

export function setHashParams(arg) {

    let hashString
    const prevState = getHashParams()

    if (typeof arg === 'function') {
        const newState = arg(prevState)
        hashString = objToHashString(newState)
    } else {
        if (typeof arg !== 'object' || Array.isArray(arg) || arg === null) return
        hashString = objToHashString(arg)
    }

    if (hashString === objToHashString(prevState)) return // do nothing if nothing changed

    if (!hashString) return clearHash()
    window.location.hash = hashString
}

function objToHashString(obj) {
    if (typeof obj !== 'object' || Array.isArray(obj) || obj === null) return ''

    const str = Object.entries(obj)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&')

    if (!str) return ''

    const hash = `#${str}`
    return hash
}

function clearHash() {
    history.replaceState(null, '', window.location.pathname + window.location.search);
}